import {
    BodyRowText, 
    StudentCell, 
    SelectionCell 
} from "./styles";
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";

const StudentTableListResponsableItem = ({
    selectedStudents
}) => {
    return (
        <tr>
            <td>
                <StudentCell>
                    <BodyRowText color="var(--dark-4)">
                        Todos
                    </BodyRowText>
                </StudentCell>
            </td>
            <td>
            </td>
            <td>
                <SelectionCell>
                    <CustomCheckbox 
                        checked={selectedStudents.allAreSelected()}
                        onChange={selectedStudents.toggleAll}
                        padding="0 10px"/>
                </SelectionCell>
            </td>
        </tr>
    );
}

export default StudentTableListResponsableItem;